import React from 'react';
import { useTheme } from '@mui/material/styles';
import { FocusTrap } from '@mui/base/FocusTrap';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import * as Bs4Utils from './Bs4Utils'

import Grow from '@mui/material/Grow';
//import Fade from '@mui/material/Fade';

export default function Bs4PopperMenu(props) {
  const theme = useTheme();
  const handleClickAway = (event) => {
    if (props.onClose) props.onClose(event);
  }
  const ref = React.useRef(null);

  return (
    <Popper 
      sx={{
        zIndex: theme.zIndex.modal,        
      }}
      placement='bottom-start'      
      {...props}
      modifiers={[
        {
          name: "preventOverflow",
          options: {
            padding: 8,
          }
        }
      ]}
      // modifiers= {[{
      //   name: 'preventOverflow',
      //   enabled: false,
      //   options: {
      //     altAxis: true,
      //     altBoundary: true,
      //     // tether: true,
      //     // rootBoundary: 'document',
      //     padding: 8,
      //   },
      // }]}
      transition
    >
      {({ TransitionProps }) => (
        <ClickAwayListener onClickAway={handleClickAway}>
          <Grow {...TransitionProps} timeout={200} style={{ transformOrigin: '0 0 0' }}>          
            <Paper               
              elevation={5} 
              onKeyDown={(event) => {
                if (event.key === 'Escape') props?.onClose(event)
              }}              
            >
              <MenuList 
                sx={{                
                  maxWidth: '90vw',
                }}
                autoFocus 
                autoFocusItem
              >
                {props.children}
              </MenuList>
            </Paper>          
          </Grow>
        </ClickAwayListener>
      )}
    </Popper>
  )
}
  
  